import React from 'react';
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {BlueButton, GreenButton, GreyButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    SystemUpdateAltTwoTone
} from "@material-ui/icons";
import TableComponent from "../common/TableComponent";
import TextField from "@material-ui/core/TextField";
import {NotificationContainer, NotificationManager} from "react-notifications";
import moment from "moment";
import {
    exportReport,
    addFlowchartRevision,
    flowchartRevision,
    flowchart, deleteFlowchart, saveOrUpdateFlowchart, flowchartUploads
} from "../../util/ApiUtils";
import {Spinner} from "../common/Spinner";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";
import "../../style/flowchart.css";
import Dropzone from "react-dropzone";
import {Table, TableHead} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import * as ApiUtils from "../../util/ApiUtils";
import {deleteFile, uploadMultipleFiles} from "../../util/OperationModuleApiUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: t('flowchart.title'),
        id: 'title',
        type: "text"
    },
];

class Flowchart2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            flowcharts: [],
            flowchartUploads: [],
            selectedFiles: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            isNew: true,
            show: false,
            step1: t('flowchart.default.step1'),
            step2: t('flowchart.default.step2'),
            step3: t('flowchart.default.step3'),
            step4: t('flowchart.default.step4'),
            step5: t('flowchart.default.step5'),
            step6: t('flowchart.default.step6'),
            title: ""
        };
        this.loadFlowCharts = this.loadFlowCharts.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.export = this.export.bind(this);
        this.loadFlowChartsRevision = this.loadFlowChartsRevision.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.deleteFileFromRecord = this.deleteFileFromRecord.bind(this);
        this.upload = this.upload.bind(this);
    }
    upload() {
        if (this.state.selectedFiles.length > 0) {
            uploadMultipleFiles("/flowchart/fileUpload",  null, this.state.selectedFiles, () => {
                NotificationManager.success(t('app.notifications.success'), t('flowchart.uploadSuccess'), 5000);
                flowchartUploads().then(response => {
                    console.log('flowchartUploads', response);
                    this.setState({
                        flowchartUploads: response,
                        selectedFiles: [],
                        isLoading: false,
                    });
                })
                    .catch(error => {
                        console.log(error);
                    });
            });
        }
    }
    showModal() {
        this.setState({
            show: true
        });
    }
    deleteFileFromRecord(fileId) {
        console.log("fileId", fileId);
        deleteFile("/flowchart/deleteFile", null, fileId)
            .then(() => {
                const remainingFiles = this.state.flowchartUploads.filter(function(file) {
                    return file.id !== fileId;
                });
                this.setState({
                    flowchartUploads: remainingFiles,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }
    onDrop(files) {
        let selectedFiles = this.state.selectedFiles;
        files.map(file => selectedFiles.push(file));
        this.setState({
            selectedFiles: selectedFiles
        });
        this.upload();
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadFlowCharts();
        this.loadFlowChartsRevision();
    }

    addRevision(request) {
        addFlowchartRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    loadFlowChartsRevision() {
        flowchartRevision()
            .then(response => {
                console.log(response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadFlowCharts() {
        flowchart()
            .then(response => {
                console.log('flowchart', response);
                this.setState({
                    flowcharts: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
        flowchartUploads().then(response => {
            console.log('flowchartUploads', response);
            this.setState({
                flowchartUploads: response,
                isLoading: false,
            });
        })
            .catch(error => {
                console.log(error);
            });
    }

    onChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    onClear() {
        this.setState({
            isNew: true,
            id: null,
            title: "",
            step1: t('flowchart.step1'),
            step2: t('flowchart.step2'),
            step3: t('flowchart.step3'),
            step4: t('flowchart.step4'),
            step5: t('flowchart.step5'),
            step6: t('flowchart.step6'),

        });
    }
    onCancel() {
        this.onClear();
    }

    onDelete(record) {
        console.log(record);
        deleteFlowchart(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success(t('app.notifications.success'), t('flowchart.removed'), 5000);
                this.onClear();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdateFlowchart(this.state)
            .then((updatedRecord) => {
                this.setState({
                    isLoading: true,
                });
                NotificationManager.success(t('app.notifications.success'), t('flowchart.updated'), 5000);
                this.onClear();
                this.loadFlowCharts();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onEdit(flowchart) {
        window.scrollTo(0, 0);
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: flowchart.id,
            step1: flowchart.step1,
            step2: flowchart.step2,
            step3: flowchart.step3,
            step4: flowchart.step4,
            step5: flowchart.step5,
            step6: flowchart.step6,
            title: flowchart.title,
        });
    }

    export() {
        exportReport('/flowchart/export');
    }

    render() {
        let { state } = this;
        if (state.isLoading) {
            return <Spinner/>;
        }
        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div ref={this.myRef}>
            <Paper className={classes.root} style={{ width: '1000px'}}>
                 <Card className={classes.card}>
                     {(!state.isEditing ?
                             <CardHeader
                                 action={
                                     <BlueButton
                                         variant="contained"
                                         color="secondary"
                                         startIcon={<AddCircleOutlineTwoTone/>}
                                         onClick={this.showModal}
                                         size="small"
                                         style={{marginRight: '10px'}}
                                         disabled={isAuditor || isViewer}
                                     >
                                        { t('common.add') }
                                     </BlueButton>
                                 }
                                 title={
                                     <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `${t('context.common.revision')} ${state.latestRevision.number} ${t('context.common.author')}: ${state.latestRevision.author}`}</b></p>
                                        <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                     </span>
                                 }
                             />
                             :
                             <CardHeader
                                 style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                 title={
                                     <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                 </span>
                                 }
                             />
                     )}
                     <CardContent>
                         {!isAuditor && !isViewer && <React.Fragment>
                             <Typography variant="h6" style={{ paddingTop: '30px', paddingLeft: "30px" }}>
                                {this.state.isNew ? t('flowchart.newTitle') : this.state.title}
                             </Typography>
                             <div style={{ paddingTop: "20px"}}>
                                 <TextField
                                     id="title"
                                     name="title"
                                     value={state.title}
                                     label={ t('flowchart.title') }
                                     onChange={this.onChange}
                                     style={{ width: "600px"}}
                                 />
                             </div>
                             <div className="grid" style={{ paddingTop: "30px" }}>
                                <div className="step arrow-down">{ t('flowchart.step1') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step1}
                                    name="step1"
                                    value={state.step1}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                    autoFocus={true}
                                /></div>
                                <div className="step arrow-down">{ t('flowchart.step2') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step2}
                                    name="step2"
                                    value={state.step2}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                /></div>
                                <div className="step arrow-down">{ t('flowchart.step3') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step3}
                                    name="step3"
                                    value={state.step3}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                /></div>
                                <div className="step arrow-down">{ t('flowchart.step4') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step4}
                                    name="step4"
                                    value={state.step4}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                /></div>
                                <div className="step arrow-down">{ t('flowchart.step5') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step5}
                                    name="step5"
                                    value={state.step5}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                /></div>
                                <div className="step">{ t('flowchart.step6') }</div>
                                <div className="step-editable"><TextField
                                    id={state.step6}
                                    name="step6"
                                    value={state.step6}
                                    multiline
                                    minRows={4}
                                    onChange={this.onChange}
                                    style={{ width: "100%", border: "1px dotted white" }}
                                /></div>
                            </div>
                            <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                <OrangeButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onCancel}
                                    style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                >
                                    { t('common.cancel') }
                                </OrangeButton>
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onSave}
                                    style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                >
                                    { this.state.isNew ? t('common.save') : t('common.update') }
                                </GreenButton>
                            </div></React.Fragment>}
                        {!isDemo && !isViewer && this.props.currentUser && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username) && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>{ t('common.export') }</GreenButton>}
                         <div style={{ paddingTop: '150px', paddingLeft: "30px", paddingRight: '30px', width: '1000px' }}>
                             <Typography component="h2" variant="h5">
                                 { t('flowchart.pageTitle') }
                             </Typography>
                             <TableComponent
                                 tableKey="flowchart"
                                 data={state.flowcharts}
                                 columns={columns}
                                 handleSubmit={this.handleSubmit}
                                 handleAddRow={this.handleAddRow}
                                 handleRowDel={this.onDelete}
                                 handleRowEdit={this.onEdit}
                                 pagination={true}
                                 allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                             />
                             <Typography component="h2" variant="h5" style={{paddingTop: '80px'}}>
                                 { t('flowchart.uploadsTitle') }
                             </Typography>
                             <div style={{ width: "800px", minHeight: "100px", paddingTop: "30px"}}>
                                 <Dropzone onDrop={(files) => this.onDrop(files)}>
                                     {({getRootProps, getInputProps}) => (
                                             <div {...getRootProps()} style={{ verticalAlign: "middle", textAlign: "center", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell", height: "100px", width: "800px"}}>
                                                 <input
                                                     {...getInputProps()}
                                                 />
                                                 <label style={{ /* backgroundColor: '#007bff', color: '#fff',*/ cursor: 'pointer', padding: 15, borderRadius: 3 }}>
                                                    { t('incident.dragDropHint') }
                                                 </label>
                                             </div>
                                     )}
                                 </Dropzone>
                             </div>
                             {
                                 (state.flowchartUploads && state.flowchartUploads.length > 0) &&
                                 <div style={{ width: "800px", paddingTop: "30px" }}>
                                     <Table>
                                         <TableHead>
                                             <tr style={{ float: "left" }}>
                                                 <th colSpan={3} style={{ textAlign: "center" }}>{ t('flowchart.uploadedDocuments') }</th>
                                             </tr>
                                         </TableHead>
                                         <TableBody>
                                             {state.flowchartUploads.map((file) => (
                                                 <tr key={file.id}>
                                                     <td>{file.fileName}</td>
                                                     <td><GreyButton onClick={() => ApiUtils.downloadFile(file.id)}>{ t('common.download') }</GreyButton></td>
                                                     <td><RedButton onClick={() => this.deleteFileFromRecord(file.id)}>{ t('common.remove') }</RedButton></td>
                                                 </tr>
                                             ))}
                                         </TableBody>
                                     </Table>
                                 </div>
                             }
                         </div>
                     </CardContent>
                 </Card>
                 <Modal
                     aria-labelledby="simple-modal-title"
                     aria-describedby="simple-modal-description"
                     open={state.show}
                     onClose={() => this.closeModal(null)}
                 >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                 </Modal>
            </Paper>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(Flowchart2);
